// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var JsxRuntime = require("react/jsx-runtime");
var LongText$ReactHooksTemplate = require("./LongText.res.js");
var Substitution$ReactHooksTemplate = require("../common/Substitution.res.js");
var SurveyLanguage$ReactHooksTemplate = require("./surveyLanguage.res.js");
var MandatoryMessage$ReactHooksTemplate = require("./MandatoryMessage.res.js");

function LongTextDefaultForm(props) {
  var substitutionVariables = props.substitutionVariables;
  var onChange = props.onChange;
  var mandatory = props.mandatory;
  var language = props.language;
  var longText = props.longText;
  var handleOnchange = function ($$event) {
    var value = $$event.target.value;
    var firstChar = value[0];
    var check = Belt_Array.getBy([
          "<",
          "=",
          "+",
          "-",
          "@"
        ], (function (x) {
            return firstChar === x;
          }));
    if (check !== undefined || value.trim() === "") {
      return Curry._1(onChange, LongText$ReactHooksTemplate.setAnswer(longText, undefined));
    } else {
      return Curry._1(onChange, LongText$ReactHooksTemplate.setAnswer(longText, value));
    }
  };
  var rawText = LongText$ReactHooksTemplate.getTextTranslation(longText, SurveyLanguage$ReactHooksTemplate.name(language));
  var rawDescription = LongText$ReactHooksTemplate.getDescriptionTranslation(longText, SurveyLanguage$ReactHooksTemplate.name(language));
  var titleHtml = Substitution$ReactHooksTemplate.renderQuestionText(rawText, substitutionVariables) + (
    mandatory ? " *" : ""
  );
  var descriptionHtml = Substitution$ReactHooksTemplate.renderQuestionText(rawDescription, substitutionVariables);
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              className: "survey-rich-text text-lg font-medium text-darkcharcoal py-6 whitespace-pre-line",
                              dangerouslySetInnerHTML: {
                                __html: titleHtml
                              }
                            }),
                        JsxRuntime.jsx("div", {
                              className: "survey-rich-text text-base font-normal text-darkcharcoal pb-8 whitespace-pre-line",
                              dangerouslySetInnerHTML: {
                                __html: descriptionHtml
                              }
                            })
                      ]
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx("textarea", {
                            className: "py-2 px-4 bg-alicebluepurple focus:border-gray-600 text-xs w-full",
                            maxLength: 3500,
                            placeholder: LongText$ReactHooksTemplate.getPlaceholderTranslation(longText, SurveyLanguage$ReactHooksTemplate.name(language)),
                            rows: 5,
                            value: Belt_Option.getWithDefault(LongText$ReactHooksTemplate.answer(longText), ""),
                            onChange: handleOnchange
                          }),
                      className: "flex w-full pb-6"
                    }),
                mandatory ? JsxRuntime.jsx(MandatoryMessage$ReactHooksTemplate.make, {
                        language: language
                      }) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
              ],
              className: "w-full px-16 small:px-6 " + props.borderCss
            });
}

var make = LongTextDefaultForm;

exports.make = make;
/* react/jsx-runtime Not a pure module */
